/**
 * Styled layout wrappers for `ChatDisclaimer` `layout` prop.
 * Naming: placement / surface (matches `ChatDisclaimerLayout` union), not "Shell".
 */
import styled, { css } from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

/** Desktop: disclaimer directly under chat input (lg+). */
export const DesktopUnderInput = styled.div`
  width: 100%;
  display: none;
  @media ${baseVariables.mediaQuery.lg} {
    display: block;
  }
`;

const mobileDisclaimerBlockShared = css`
  display: block;
  width: 100%;
  flex-shrink: 0;
  box-sizing: border-box;

  @media ${baseVariables.mediaQuery.lg} {
    display: none;
  }

  p,
  span {
    text-align: center !important;
  }

  > div {
    justify-content: center;
    align-items: center;
  }

  > div > div {
    justify-content: center;
    text-align: center;
    margin-right: 0 !important;
  }
`;

/**
 * Mobile new chat (empty): below header, above messages scroller — stays top-aligned.
 */
export const MobileTopBar = styled.div`
  ${mobileDisclaimerBlockShared}
  padding: 1.5rem;
  text-align: center;
`;

/**
 * Mobile thread: first row inside messages scroller (scrolls with bubbles). Horizontal
 * inset comes from `MessagesContainer` padding.
 */
export const MobileMessagesInline = styled.div`
  ${mobileDisclaimerBlockShared}
  text-align: center;
  padding: 0 24px 0 0;
`;

/** Welcome-only: pinned to bottom of chat column on desktop (lg+). */
export const WelcomeDesktopFooter = styled.div`
  display: none;
  width: 100%;
  box-sizing: border-box;
  padding: 0 1.5rem 0.5rem;
  padding-bottom: calc(0.5rem + env(safe-area-inset-bottom));

  @media ${baseVariables.mediaQuery.lg} {
    display: block;
  }
`;

/**
 * Welcome-only mobile: floating card above input (hidden lg+). Horizontal inset 1.5rem.
 * Inner layout targets the disclaimer root class passed from the host (e.g. OChat).
 */
export const DismissibleWelcomeMobileCard = styled.div`
  display: block;
  position: relative;
  align-self: stretch;
  width: auto;
  box-sizing: border-box;
  flex-shrink: 0;
  margin: 0 1.5rem 16px;
  padding: 8px 44px 8px 16px;
  background-color: var(--t-brand-bg-color, #ffffff);
  border: 1px solid var(--colors-neutral-20, #eeeeee);
  border-radius: 14px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.07);

  @media ${baseVariables.mediaQuery.lg} {
    display: none;
  }

  .o-chat-welcome-mobile-disclaimer {
    width: 100%;
  }

  .o-chat-welcome-mobile-disclaimer > div {
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    margin-right: 0 !important;
  }

  p,
  span {
    text-align: left !important;
  }
`;

export const DismissibleWelcomeMobileClose = styled.button.attrs({ type: 'button' })`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--t-brand-fg-color, #1c1c1c);
  z-index: 1;
  padding: 0;

  &:focus-visible {
    outline: 2px solid var(--t-brand-fg-color, #1c1c1c);
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
